var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6363 5.06368C12.4675 4.89495 12.2386 4.80017 12 4.80017C11.7613 4.80017 11.5325 4.89495 11.3637 5.06368L5.06368 11.3637C4.89973 11.5334 4.80902 11.7608 4.81107 11.9967C4.81312 12.2327 4.90777 12.4584 5.07464 12.6253C5.24151 12.7922 5.46724 12.8868 5.70321 12.8889C5.93919 12.8909 6.16653 12.8002 6.33628 12.6363L6.59998 12.3726V18.3C6.59998 18.5387 6.6948 18.7676 6.86358 18.9364C7.03236 19.1052 7.26128 19.2 7.49998 19.2H9.29998C9.53867 19.2 9.76759 19.1052 9.93637 18.9364C10.1052 18.7676 10.2 18.5387 10.2 18.3V16.5C10.2 16.2613 10.2948 16.0324 10.4636 15.8636C10.6324 15.6948 10.8613 15.6 11.1 15.6H12.9C13.1387 15.6 13.3676 15.6948 13.5364 15.8636C13.7052 16.0324 13.8 16.2613 13.8 16.5V18.3C13.8 18.5387 13.8948 18.7676 14.0636 18.9364C14.2324 19.1052 14.4613 19.2 14.7 19.2H16.5C16.7387 19.2 16.9676 19.1052 17.1364 18.9364C17.3052 18.7676 17.4 18.5387 17.4 18.3V12.3726L17.6637 12.6363C17.8334 12.8002 18.0608 12.8909 18.2967 12.8889C18.5327 12.8868 18.7584 12.7922 18.9253 12.6253C19.0922 12.4584 19.1868 12.2327 19.1889 11.9967C19.1909 11.7608 19.1002 11.5334 18.9363 11.3637L12.6363 5.06368Z",
    stroke: "#3F3F46",
    fillOpacity: 0.86,
    fill: "#3F3F46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.4ca0c76454d931f02442abc800b319a1.svg";
export { ForwardRef as ReactComponent };